import{jsx as t}from"react/jsx-runtime";import{CSSTransition as r}from"react-transition-group";import e from"styled-components";const s={classNames:"backgroundTransition",timeout:{enter:400,exit:400},mountOnEnter:!0,unmountOnExit:!0},c=e.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);

  &.backgroundTransition-enter {
    opacity: 0;
  }

  &.backgroundTransition-enter.backgroundTransition-enter-active {
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }

  &.backgroundTransition-exit {
    opacity: 1;
  }

  &.backgroundTransition-exit.backgroundTransition-exit-active {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
`,u=({className:n,isOpen:o,onClick:i,transitionProps:a=s})=>t(r,{in:o,...a,className:n,children:t(c,{onClick:()=>{i&&i()}})});export{u as default};
